
















import {
  Component,
  Prop,
  Mixins,
} from 'vue-property-decorator';
import { like, and } from '@/classes/pimcore-filtering/Filters';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';
import NormalizerMixin from '@/mixins/NormalizerMixin';

@Component
export default class EntityFilter extends Mixins(EntityHelperMixin, NormalizerMixin) {
  @Prop({
    type: String,
    default: false,
  }) readonly filterEntity!: string

  @Prop({
    type: String,
    default: false,
  }) readonly fieldName!: string

  @Prop({
    type: Object,
    required: false,
    default: () => ({}),
  }) readonly variables!: any

  loading = false;

  filterValue = '';

  items: Array<any> = [];

  get entity() {
    return this.filterEntity;
  }

  get capitalizedName() {
    return this.fieldName.charAt(0).toUpperCase() + this.fieldName.slice(1);
  }

  async beforeMount() {
    this.$bus.$on('clear-filters', (item: any) => {
      this.filterValue = '';
      this.setToStorage(this.fieldName, '');
    });
  }

  async mounted() {
    await this.fetchFilterItems();
    this.$emit('loaded');
  }

  beforeDestroy() {
    this.$bus.$off('clear-filters');
  }

  async fetchFilterItems() {
    this.loading = true;
    this.items = await this.loadEntityListing(
      this.entity,
      this.variables,
      'network-only',
      { maxDepth: 1, byObject: this.getNormalizerRequiredFields(this.entity) },
    );

    const storageVal = this.getFromStorage(this.fieldName);
    if (storageVal !== '') {
      this.filterValue = storageVal;
      this.setFilter(storageVal);
    }

    this.loading = false;
  }

  setFilter(value: any) {
    this.$emit('setFilter', this.entityFilter(value));
    this.$emit('change', value);
  }

  onSearch(value: any) {
    this.setToStorage(this.fieldName, value);
    this.setFilter(value);
    this.$emit('onSearch');
  }

  entityFilter(value: any) {
    if (!value) {
      return null;
    }
    return and(like(`${this.fieldName}__id`, value));
  }

  get filterItems() {
    return this.items.map((v) => {
      const normalizedValue = this.normalizeValue(v);
      return {
        text: `${v.id} - ${normalizedValue}`,
        value: v.id,
      };
    });
  }
}

